import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GuestTeamDataAndSchemas, ITeamSettingsState } from "./definitions";
import {
  basicAuditFormSchema,
  basicAuditSchema,
} from "models/generateAuditSchemas";
import {
  basicGaiaObjFormSchema,
  basicGaiaObjSchema,
} from "models/generateGaiaObjSchemas";
import { Team } from "models/schemas";

const initialState: ITeamSettingsState = {
  // TODO: remove selectedTeam and isUserCriticalInTeam and update corresponding components to use the new attributes below
  selectedTeam: {} as Team,
  isUserCriticalInTeam: false,
  // This is the team main meta data from backend
  selectedTeamMainMetaData: {
    teamId: "",
    teamDescription: "",
    auditTitleFormula: "",
    ldapGroupId: "",
    isCritical: false,
    dateFormat: "",
  },
  auditSchemas: {
    // This is the schema for all attributes when we try to create/edit the audit including the visible and invisible attributes
    auditSchema: basicAuditSchema,
    // This is the schema for creating/editing the audit including all the visible attributes
    auditFormSchema: basicAuditFormSchema,
  },
  noticeSchemas: {
    gaiaObjSchema: basicGaiaObjSchema,
    gaiaObjFormSchema: basicGaiaObjFormSchema,
  },
  litigationSchemas: {
    gaiaObjSchema: basicGaiaObjSchema,
    gaiaObjFormSchema: basicGaiaObjFormSchema,
  },
  allTeams: [], // this contains the real teams this user is member of
  guestTeamDataAndSchemasMap: {}, // it's a map with teamId : team info. The team info includes setAudit/Notice/LitigationSchemas and TeamMainMetaData
  currentGuestTeam: undefined, // current guest team data and schemas
  userTeamCriticalnessMap: {},
};

export const teamSettingsSlice = createSlice({
  name: "teamSettings",
  initialState,
  reducers: {
    setTeamById: (state, action) => {
      return {
        ...state,
        selectedTeam: action.payload,
      };
    },
    removeSelectedTeam: (state) => {
      state.selectedTeam = {} as Team;
    },
    setIsUserCriticalInTeam: (state, action) => {
      state.isUserCriticalInTeam = action.payload;
    },
    setSelectedTeamMainMetaData: (state, action) => {
      return {
        ...state,
        selectedTeamMainMetaData: action.payload,
      };
    },
    setAuditSchemas: (state, action) => {
      return {
        ...state,
        auditSchemas: action.payload,
      };
    },
    setNoticeSchemas: (state, action) => {
      return {
        ...state,
        noticeSchemas: action.payload,
      };
    },
    setLitigationSchemas: (state, action) => {
      return {
        ...state,
        litigationSchemas: action.payload,
      };
    },
    setAllTeams: (state, action) => {
      return {
        ...state,
        allTeams: action.payload,
      };
    },
    setGuestTeamsDataAndSchemasMap: (state, action) => {
      return {
        ...state,
        guestTeamDataAndSchemasMap: action.payload,
      };
    },
    setUserTeamCriticalnessMap: (state, action) => {
      return {
        ...state,
        userTeamCriticalnessMap: action.payload,
      };
    },
    setCurrentGuestTeam: (
      state,
      action: PayloadAction<GuestTeamDataAndSchemas>
    ) => {
      state.currentGuestTeam = action.payload;
    },
  },
});

export const {
  setTeamById,
  removeSelectedTeam,
  setIsUserCriticalInTeam,
  setAllTeams,
  setGuestTeamsDataAndSchemasMap,
  setUserTeamCriticalnessMap,
  setSelectedTeamMainMetaData,
  setAuditSchemas,
  setNoticeSchemas,
  setLitigationSchemas,
  setCurrentGuestTeam,
} = teamSettingsSlice.actions;
export default teamSettingsSlice.reducer;
